import React, { Component } from 'react';

class AlmacenInventario extends Component {
    render() {
        return (
            <div>
                inventario almacen
            </div>
        );
    }
}

export default AlmacenInventario;